/* eslint-disable react/display-name */
import {createVariant} from '@base/react-utils'

import FeedbackStatus from '@base-uikit/feedback/status/FeedbackStatus'
import type {Props as FeedbackStatusProps} from '@base-uikit/feedback/status/FeedbackStatus'
import {ComponentLoading, Success} from '@base-uikit/feedback/status/Indicator'

import InputErrorIndicator from './InputErrorIndicator'

import baseTheme from './InputFeedbackStatus.css'

const InputSuccessIndicator = createVariant(Success, {
  displayName: 'InputSuccessIndicator',
  defaultProps: {
    color: 'success',
  },
})

export default createVariant<
  FeedbackStatusProps & {opened?: boolean},
  FeedbackStatusProps
>(FeedbackStatus, {
  displayName: 'InputFeedbackStatus',
  defaultProps: {
    size: 's',
    loadingIndicator: ComponentLoading,
    successIndicator: InputSuccessIndicator,
    errorIndicator: InputErrorIndicator,
  },
  theme: baseTheme,
})
